/* PWW v114: smart wheel search resolves diameter, optional wheel width, and
   every compatible bolt-pattern facet value (including multi-drill values).
   Examples: 18x 5x114, 18x10 5x114.3, 20 x 9 6x139.7. */
(function () {
  'use strict';

  var BOLT_FILTER_NAME = 'filter.p.m.custom.wheel_bolt_pattern';
  var WIDTH_FILTER_NAME = 'filter.p.m.custom.wheel_width';

  function parseWheelSearch(value) {
    var query = String(value || '')
      .toLowerCase()
      .replace(/[×]/g, 'x')
      .replace(/\s+/g, ' ')
      .trim();
    if (!query) return null;

    var diameterMatch = query.match(/^(?:rim|rims|wheel|wheels)?\s*(1[4-9]|2[0-9]|30)(?:\s*(?:inch|inches|in|"))?(?=\s|x|$)/i);
    if (!diameterMatch) return null;

    var boltMatch = query.match(/(?:^|[^0-9])([3-9]|10)\s*x\s*(9[0-9](?:\.\d+)?|1[0-9]{2}(?:\.\d+)?|200(?:\.0+)?)(?:\s*mm)?(?:$|[^0-9])/i);
    if (!boltMatch) return null;

    var diameter = String(parseInt(diameterMatch[1], 10));
    var lugCount = String(parseInt(boltMatch[1], 10));
    var pcd = String(parseFloat(boltMatch[2]));
    if (pcd === '114') pcd = '114.3';

    // Width is only accepted when it is a separate dimension before the bolt
    // pattern. This prevents "18x 5x114" from treating the lug count 5 as width.
    var prefixBeforeBolt = query.slice(0, boltMatch.index).trim();
    var widthMatch = prefixBeforeBolt.match(/^(?:rim|rims|wheel|wheels)?\s*(?:1[4-9]|2[0-9]|30)(?:\s*(?:inch|inches|in|"))?\s*x\s*(\d{1,2}(?:\.\d+)?)\s*$/i);
    var width = widthMatch ? String(parseFloat(widthMatch[1])) : '';

    return {
      diameter: diameter,
      width: width,
      boltPattern: lugCount + 'x' + pcd
    };
  }

  function normalizePattern(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/[×]/g, 'X')
      .replace(/\s+/g, '')
      .replace(/MM/g, '');
  }

  function numericFacetValue(value) {
    var match = String(value || '').replace(',', '.').match(/\d+(?:\.\d+)?/);
    return match ? parseFloat(match[0]) : NaN;
  }

  function canonicalBoltFallback(pattern) {
    return String(pattern || '').toUpperCase() + 'mm';
  }

  function buildTarget(parsed, originalQuery, facetValues) {
    var params = new URLSearchParams();
    var bolts = facetValues && facetValues.bolts && facetValues.bolts.length
      ? facetValues.bolts
      : [canonicalBoltFallback(parsed.boltPattern)];

    bolts.forEach(function (value) {
      params.append(BOLT_FILTER_NAME, value);
    });

    if (parsed.width) {
      var widths = facetValues && facetValues.widths && facetValues.widths.length
        ? facetValues.widths
        : [parsed.width];
      widths.forEach(function (value) {
        params.append(WIDTH_FILTER_NAME, value);
      });
    }

    params.set('pww_search', String(originalQuery || '').trim());
    params.set('sort_by', 'price-ascending');
    return '/collections/' + parsed.diameter + '-wheel?' + params.toString();
  }

  async function resolveFacetValues(parsed) {
    var collectionPath = '/collections/' + parsed.diameter + '-wheel';
    var response = await fetch(collectionPath + '?sort_by=price-ascending', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'PWW-Smart-Wheel-Search' }
    });
    if (!response.ok) throw new Error('Facet lookup failed: ' + response.status);

    var html = await response.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var requestedBolt = normalizePattern(parsed.boltPattern);
    var requestedWidth = parsed.width ? parseFloat(parsed.width) : NaN;
    var bolts = [];
    var widths = [];

    doc.querySelectorAll('input[name="' + BOLT_FILTER_NAME + '"]').forEach(function (input) {
      var value = String(input.value || '').trim();
      var normalized = normalizePattern(value);
      if (normalized.indexOf(requestedBolt) !== -1 && bolts.indexOf(value) === -1) {
        bolts.push(value);
      }
    });

    if (!isNaN(requestedWidth)) {
      doc.querySelectorAll('input[name="' + WIDTH_FILTER_NAME + '"]').forEach(function (input) {
        var value = String(input.value || '').trim();
        var numeric = numericFacetValue(value);
        if (!isNaN(numeric) && Math.abs(numeric - requestedWidth) < 0.001 && widths.indexOf(value) === -1) {
          widths.push(value);
        }
      });
    }

    return { bolts: bolts, widths: widths };
  }

  async function routeQuery(query, replace) {
    var parsed = parseWheelSearch(query);
    if (!parsed) return false;

    var facetValues = { bolts: [], widths: [] };
    try {
      facetValues = await resolveFacetValues(parsed);
    } catch (error) {
      console.warn('PWW smart wheel search used fallback filters.', error);
    }

    var url = buildTarget(parsed, query, facetValues);
    if (replace) window.location.replace(url);
    else window.location.assign(url);
    return true;
  }

  if (window.location.pathname === '/search') {
    var currentParams = new URLSearchParams(window.location.search);
    var currentQuery = currentParams.get('q') || '';
    if (parseWheelSearch(currentQuery)) {
      routeQuery(currentQuery, true);
      return;
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || String(form.tagName).toLowerCase() !== 'form') return;
    var input = form.querySelector('input[type="search"][name="q"], input[name="q"]');
    if (!input || !parseWheelSearch(input.value)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    routeQuery(input.value, false);
  }, true);

  window.PWWSmartWheelSearch = {
    parse: parseWheelSearch,
    resolveFacetValues: resolveFacetValues,
    buildTarget: buildTarget
  };
})();

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', debounce((event) => { this.onChange(event); }, 300).bind(this));
    }
  }
  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) this.resetButton.classList.remove('hidden');
    else if (this.input.value.length === 0 && !resetIsHidden) this.resetButton.classList.add('hidden');
  }
  onChange() { this.toggleResetButton(); }
  shouldResetForm() { return !document.querySelector('[aria-selected="true"] a'); }
  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
if (!customElements.get('search-form')) customElements.define('search-form', SearchForm);
